import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';
import { LoginRequest } from '../api/login/loginrequest';
import { LoginResponse, LoginResponseDtoImpl } from '../api/login/loginresponse';

export class LoginAPIProcessorImpl extends APIProcessorImpl<LoginRequest, LoginResponse>
{
    private LOGGER: Logger = LogManager.getLogger(LoginAPIProcessorImpl.name);
     execute(request: LoginRequest): void
    {
        super.execute(request);
    }
      /* execute()
     {
         console.log("execute() in LoginPIProcessorImpl"); 

         let LoginResponse = new LoginResponseDtoImpl(APIFeatures.LOGIN, "Valid Password");
        
         let responseMapDto = new ResponseMapDtoImpl();
         responseMapDto.setAccessToken("1e3a077e-445a-40ac-baf3-f8ee50767bc4");
         responseMapDto.setRefreshToken("b74628e1-8457-4f2c-9d92-1bed00bbfcd2");
         responseMapDto.setDeviceId("1");
         responseMapDto.setExpiry(800000);
         LoginResponse.setMessage("Success");
         LoginResponse.setRespTime("Apr 8, 2020 12:15:07 PM");
         LoginResponse.setStatusCode("SC0000");
         LoginResponse.setResponseMap(responseMapDto);
         LoginResponse.setSettings("\"settings\":{}");
             
         this.getAPISuccess(LoginResponse);
     }  */
    /*  "accessToken": "1e3a077e-445a-40ac-baf3-f8ee50767bc4",
    "refreshToken": "b74628e1-8457-4f2c-9d92-1bed00bbfcd2",
     "msisdn": "0504843969",
     "deviceId": "67c49626-558d-486a-abbb-5e035ae41b8e",
     "expiry": 600000, */
     onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            this.LOGGER.log("onSuccess() invoked : "+responseMapper.getStatusCode());
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new LoginResponseDtoImpl(APIFeatures.LOGIN , "Valid Password");

                let responseMap = responseMapper.getResponseMap();
                let getUserContext = this.getContext().getUserContext();
                let context = this.getContext();

                getUserContext.setAccessToken(responseMap.accessToken);
                getUserContext.setRefreshToken(responseMap.refreshToken);
                context.setUserContext(getUserContext);
                
                this.LOGGER.log("Access Token : "+getUserContext.getAccessToken());
                this.LOGGER.log("Refresh Token : "+getUserContext.getRefreshToken());
                
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new LoginResponseDtoImpl(APIFeatures.LOGIN, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new LoginResponseDtoImpl(APIFeatures.LOGIN, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new LoginResponseDtoImpl(APIFeatures.LOGIN, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new LoginResponseDtoImpl(APIFeatures.LOGIN, responseMapper.getStatusMsg()));
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/loginapiprocessor.tsx